module.exports = __webpack_public_path__ + "img/check.63f463ed.svg";